window.getIpLocation = function (onSuccess, onError) {
  jQuery.getJSON('https://daiwa-au-b2c.devotedigital.workers.dev/?type=geoip')
    .done(function (data) { if (typeof onSuccess === 'function') onSuccess(data); })
    .fail(function () { if (typeof onError === 'function') onError({ error: 'geoip unavailable' }); });
};

//Fallback start
function getDistanceFromLatLonInKm(lat1,lon1,lat2,lon2) {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2-lat1);  // deg2rad below
  var dLon = deg2rad(lon2-lon1); 
  var a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon/2) * Math.sin(dLon/2); 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c; // Distance in km
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI/180);
}

async function getDestination() {
  var response = await $.getJSON('https://daiwa-au-b2c.devotedigital.workers.dev/?type=store-locator');
  var csvHeader = response.valueRanges['0'].values['0'];
  var data = [];
  for (i = 1; i < response.valueRanges['0'].values.length; i++) {
    var dataPush = [];
    for (x = 0; x < csvHeader.length; x++) {
      dataPush[csvHeader[x]] = response.valueRanges['0'].values[i][x];
    }
    data.push(dataPush);
  }
  return data;
}

async function getNearestDealer (origin) {
  var destination = await getDestination();
  var i;
  var distance= [];
  for (i = 0; i < destination.length; i++) { 
    var calDistance = getDistanceFromLatLonInKm(origin.lat, origin.long, destination[i].Latitude, destination[i].Longitude);
    distance[i] = {loc: destination[i].Shop_Name, dist: calDistance} 
  }
  var lowest = Number.POSITIVE_INFINITY;
  var fclity = "";
  var tmp;
  for (i = 0; i < distance.length; i++) { 
    tmp = distance[i].dist;
    if (tmp < lowest) {
      lowest = tmp;
      fclity = distance[i].loc;
    }
  }
  return fclity;	
}
   
window.setDealer = async function () {
    getIpLocation(async function(response){
      var result = {lat: response.location.latitude , long: response.location.longitude, city: response.city.names.en};
      var nearestStore = await getNearestDealer (result);
      Cookies.set('nearestStore', nearestStore,{ expires: 1 });
      $('#panel-hide').html('<a class="find-a-store" href="/pages/stores"><span class="store-list-near"><div class="title">'+ nearestStore +'</div></span></a>');
    }, function(error){})
}

//Check if allowed
window.checkCookieStore = function() {
  var nearest = Cookies.get('nearestStore');
  if (Cookies.get('nearestStore')) {
    return nearest;
  }
  else {
    return null;
  }
}

//Additional 
window.getLocationCityLatLon = async function(lat,lon){
  var response = await $.getJSON('https://daiwa-au-b2c.devotedigital.workers.dev/?type=geocode&latlng='+ lat + ',' + lon, function() {});
  return response;
}

jQuery(document).ready(function(){
  var nearestStore = Cookies.get('nearestStore');
  if(nearestStore){
    $('#panel-hide').html('<a class="find-a-store" href="/pages/stores"><span class="store-list-near"><div class="title">'+ nearestStore +'</div></span></a>');
  } else {
    setDealer();
  }
});